import DeviceSelectDialog from '@/api/device/deviceSelectDialog.vue'
import Vue from 'vue'
import { userInfo } from '@/global.js'
import { qryDicDetailByCode } from '@/api/biz/shipment/pack/pack.js'
import { i18n } from '@/api/i18n'
export async function deviceSelect(deviceList) {
    return new Promise((resolve, reject) => {
        let DialogConstructor = Vue.extend(DeviceSelectDialog)
        let vm = new DialogConstructor()
        vm.$mount()
        vm.open(i18n.t('rfidwaitPleaseSelect'), deviceList,
            (selectedDevice) => {
                if (selectedDevice) {
                    resolve(selectedDevice.code)
                }
                reject()
            },
            () => {
                reject()
                // 用户取消选择
                console.log('用户取消了设备选择')
            }
        )
    })
}


// 获取思创里德系统配置
export async function getCenturyleadDeviceSysConfig() {
    // 获取条码处理规则
    let config = {}
    try {
        let dicDetails = await qryDicDetailByCode(
            "RFID_CONFIG_SCLD",
            userInfo
        );
        dicDetails.find(item => {
            if (item.code === 'BARCODE_ANALYSIS') config.ruleStr = item.value
            else if (item.code === 'RFID_CONFIG_POWER') config.power = item.value
            else if (item.code === 'RFID_CONFIG_BASE_URL') config.url = item.value
            else if (item.code === 'RFID_CONFIG_TRIGGER_DELAY') {
                let num = Number(item.value)
                config.triggerDelay = Number.isNaN(num) ? 2000 : num
            } else if (item.code === 'RFID_CONFIG_WAIT_LINK_TIMEOUT'){
                let num = Number(item.value)
                config.timeout = Number.isNaN(num) ? 2000 : num
            }
        })

        let ruleStr = config.ruleStr || ''
        const parts = ruleStr.split('-')
        if (parts.length === 2) {
            config.rule = [parseInt(parts[0], 10) - 1, parseInt(parts[1], 10)]
        }
        console.log("🚀 ~ rule:", config.rule)
    } catch (error) {
        console.error("🚀 ~ error:", error)
    } finally {
        return config
    }
}

// 判断扫描的barcode
export function goodsJudgment(goodsInfo, barcodeObj, codeObj, cacheEpcList, deviceEpcToBarCode) {
    let normalList = []
    let abnormalList = []
    let mem = { ...barcodeObj }
    let repeatList = []
    if(Array.isArray(cacheEpcList) && cacheEpcList.length > 0){
        cacheEpcList.forEach(epcCode => {
            let barcode =  deviceEpcToBarCode(epcCode)
            let arr = codeObj[barcode]
            if(Array.isArray(arr) && arr.indexOf(epcCode) > -1){
                repeatList.push(arr.splice(arr.indexOf(epcCode), 1))
                mem[barcode]--
            }
        })
        if(repeatList.length > 0){
            abnormalList.push({
                barcode: repeatList.join(','),
                epcCodeList: repeatList,
                epcQty: repeatList.length,
                epcType: 'barcodeDuplicate'
            })
        }
    }
    goodsInfo.forEach(item => {
        let barcodeList = Array.isArray(item.goodsBarcodeList) ? item.goodsBarcodeList : []
        let unCheckQty = 0
        // if (item.barcode) barcodeList.push(item.barcode)
        let matchBarcodeList = []
        barcodeList.forEach(barcode => {
            let barcodeLength = mem[barcode] || 0
            if (barcodeLength > 0) {
                matchBarcodeList.push(...codeObj[barcode])
                unCheckQty += barcodeLength
            }
        })
        if (unCheckQty > 0) {
            let barcode = barcodeList.join(',')
            // 正常
            if (item.unCheckQty - unCheckQty >= 0) {
                normalList.push({
                    ...item,
                    barcode,
                    epcCodeList: matchBarcodeList,
                    epcQty: unCheckQty,
                })
            } else {
                if (item.unCheckQty > 0) {
                    normalList.push({
                        ...item,
                        barcode,
                        epcCodeList: matchBarcodeList.splice(0, item.unCheckQty),
                        epcQty: item.unCheckQty,
                    })
                }
                abnormalList.push({
                    ...item,
                    barcode: matchBarcodeList.join(','),
                    epcCodeList: matchBarcodeList,
                    epcQty: unCheckQty - item.unCheckQty,
                    epcType: 'diffMore'
                })
            }
            barcodeList.forEach(barcode => {
                delete mem[barcode]
            })
        }

    })
    Object.keys(mem).forEach(barcode => {
        let epcCodeList = Array.isArray(codeObj[barcode]) ? codeObj[barcode] : []
        if(epcCodeList.length > 0){
            abnormalList.push({
                barcode: epcCodeList.join(','),
                epcCodeList: epcCodeList,
                epcQty: mem[barcode],
                epcType: 'SKUNotExist'
            })
        } 
    })
    return {
        normalList,
        abnormalList
    }
}